/**
 * ElevenLabs ConvAI embed, loaded only after the user accepts the Help notice.
 *
 * Until that acceptance, this module must not write cookies, localStorage, or
 * sessionStorage, and must not request ElevenLabs. The marketing-site cookie
 * banner (`speak-cookie-consent` in localStorage) covers HubSpot on speak.ad
 * and does not cover this chat. After acceptance, the choice is kept in
 * sessionStorage for the tab session only.
 */

export const ELEVENLABS_CONVAI_SCRIPT_SRC =
  "https://unpkg.com/@elevenlabs/convai-widget-embed";

const HELP_CHAT_CONSENT_KEY = "speak.helpChat.elevenlabs";
const HELP_CHAT_CONSENT_VALUE = "accepted";

export function hasHelpChatConsent(): boolean {
  try {
    return sessionStorage.getItem(HELP_CHAT_CONSENT_KEY) === HELP_CHAT_CONSENT_VALUE;
  } catch {
    return false;
  }
}

export function rememberHelpChatConsent(): void {
  try {
    sessionStorage.setItem(HELP_CHAT_CONSENT_KEY, HELP_CHAT_CONSENT_VALUE);
  } catch {
    // sessionStorage can throw in private-mode or test sandboxes.
  }
}

/** Inject the ConvAI embed script once. Does nothing until called. */
export function ensureElevenLabsConvaiScript(): void {
  const existing = document.querySelector(
    `script[src="${ELEVENLABS_CONVAI_SCRIPT_SRC}"]`,
  );
  if (existing) return;

  const script = document.createElement("script");
  script.src = ELEVENLABS_CONVAI_SCRIPT_SRC;
  script.async = true;
  script.type = "text/javascript";
  document.body.appendChild(script);
}
